/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class ErrorsParser {

    // TODO Divide by operator
    static errors = [
        'TypeError: Cannot read property \'wrapperResponse\' of undefined',
        'Cannot read property \'wrapperResponse\' of undefined',
        'Cannot read property "wrapperResponse" of undefined',
        'vanillaApp is not defined',
        'ReferenceError: Can\'t find variable: dla',
        'Can\'t find variable: dla',
        'ReferenceError: Can\'t find variable: dla',
        'Can\'t find variable: dla',
        'Uncaught ReferenceError: dla is not defined',
        'dla is not defined',
        'Uncaught ReferenceError: require is not defined',
        'ReferenceError: require is not defined',
        'Android wrapper script already exist',
        'Uncaught ReferenceError: jBone is not defined',
        'jBone is not defined',
        'TypeError: Cannot read property \'h\' of undefined',
        'Cannot read property \'h\' of undefined',
        'Uncaught InvalidStateError: Failed to read the \'responseText\' property from \'XMLHttpRequest\'',
        'Failed to read the \'responseText\' property from \'XMLHttpRequest\'',
        'news_page',
        'The current window does not have permission to navigate the target frame to \'https://www.volcanobet.me//casino\'',
        'https://m.volcanobet.me//casino',
        'ReferenceError: Can\'t find variable: AppSwitched',
        'Can\'t find variable: AppSwitched',
        'TypeError: undefined is not an object (evaluating \'document.getElementsByClassName(\'gotya1\')[0].value\')',
        'TypeError: undefined is not an object (evaluating \'document.getElementsByClassName(\'gotya2\')[0].value\')',
        'ReferenceError: Can\'t find variable: UserInfo',
        'ReferenceError: Can\'t find variable: PlatformJWTManager',
        'Uncaught ReferenceError: AppCallbackInterface is not defined',
        'TypeError: undefined is not an object (evaluating \'window.ucbrowser.smWeather.changecity\')',
        'window.ucbrowser.smWeather.changecity',
        'ReferenceError: Can\'t find variable: AppInterface',
        'ReferenceError: Can\'t find variable: onGetInfoComplete_v2',
        'Uncaught ReferenceError: x5onSkinSwitch is not defined',
        'TypeError: undefined is not an object (evaluating \'SogouMse.videoPauseTool.pauseVideo\')',
        'SogouMse.videoPauseTool.pauseVideo',
        'ReferenceError: Can\'t find variable: AppRestored',
        'TypeError: null is not an object (evaluating \'window.mttLongPressVar.tagName\')',
        'window.mttLongPressVar.tagName',
        'JSON Parse error: Unexpected identifier "object',
        't.unbind is not a function',
        'Cannot read property \'gameResized\' of null',
        'this.commonUI is null',
        'angular is not defined',
        'Could not find a theme for operator defaultTheme, reverting to default theme',
        'Get source language error: received empty value or error callback from getPageLanguage',
        'window.realWalletUpdate is not a function.',
        'window.bonusWalletUpdate is not a function',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'TypeError: Cancelled',
        'ReferenceError: Can\'t find variable: WH',
        'Can\'t find variable: WH',
        'WebGL not available for compressed textures. Silently failing.',
        'InvalidStateError: Failed to start the audio device',
        '[bridge] #refreshBalance: userBalance request failed!',
        'Error: Method not found'
    ];

    static parse(cfg, settings, options) {
        cfg.errors = {
            connection: {
                nonRecoverable: Boolean(options.isNetent) || Boolean(options.isRTG && options.isTable),
            },
            list: ErrorsParser.errors.map(error => {
                return {
                    match: error,
                    type: 'operator',
                    isSilent: true
                };
            })
        };
        return cfg.errors;
    }

}


module.exports = ErrorsParser;
